import { render, staticRenderFns } from "./PageTitleBanner.vue?vue&type=template&id=656f9dfe"
import script from "./PageTitleBanner.vue?vue&type=script&lang=js"
export * from "./PageTitleBanner.vue?vue&type=script&lang=js"
import style0 from "./PageTitleBanner.vue?vue&type=style&index=0&id=656f9dfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports